export const SPRITES = {
  "elena": {
    srcs: "assets/characters/elena-{variation}.png",
    variations: ['neutral', 'happy', 'sad', 'embarrassed', 'crying', 'surprised', 'angry', 'thinking'],
    width: 416,
    height: 624
  },
  "kael": {
    srcs: "assets/characters/kael-{variation}.png",
    variations: ['neutral', 'happy', 'sad', 'embarrassed', 'crying', 'surprised', 'angry', 'thinking'],
    width: 416,
    height: 624
  },
  "zara": {
    srcs: "assets/characters/zara-{variation}.png",
    variations: ['neutral', 'happy', 'sad', 'embarrassed', 'crying', 'surprised', 'angry', 'thinking'],
    width: 416,
    height: 624
  },
  "nyx": {
    srcs: "assets/characters/nyx-{variation}.png",
    variations: ['neutral', 'happy', 'sad', 'embarrassed', 'crying', 'surprised', 'angry', 'thinking'],
    width: 416,
    height: 624
  },
  "orion": {
    srcs: "assets/characters/orion-{variation}.png",
    variations: ['neutral', 'happy', 'sad', 'embarrassed', 'crying', 'surprised', 'angry', 'thinking'],
    width: 416,
    height: 624
  },
  "elenaBriefingRoom": {
    srcs: "assets/locations/elena-briefing-room.png",
    width: 1216,
    height: 960
  },
  "solarisInterior": {
    srcs: "assets/locations/solaris-interior.png",
    width: 1216,
    height: 960
  },
  "abandonedStation": {
    srcs: "assets/locations/abandoned-station.png",
    width: 1216,
    height: 960
  },
  "homePageBackground": {
    srcs: "assets/pages/homePageBackground.png",
    width: 1216,
    height: 960
  },
  "commandCenter": {
    srcs: "assets/locations/command-center.png",
    width: 1216,
    height: 960
  },
  "asteroidBase": {
    srcs: "assets/locations/asteroid-base.png",
    width: 1216,
    height: 960
  },
  "weaponControlRoom": {
    srcs: "assets/locations/weapon-control-room.png",
    width: 1216,
    height: 960
  },
  "nyxQuarters": {
    srcs: "assets/locations/nyx-quarters.png",
    width: 1216,
    height: 960
  },
  "elenasQuarters": {
    srcs: "assets/locations/elenas-quarters.png",
    width: 1216,
    height: 960
  },
  "conflictPlanet": {
    srcs: "assets/locations/conflict-planet.png",
    width: 1216,
    height: 960
  },
  "negotiationRoom": {
    srcs: "assets/locations/negotiation-room.png",
    width: 1216,
    height: 960
  },
  "starryView": {
    srcs: "assets/locations/starry-view.png",
    width: 1216,
    height: 960
  },
  "starshipBridge": {
    srcs: "assets/locations/starship-bridge.png",
    width: 1216,
    height: 960
  }
}

export const SOUNDS = {}
